import { render, staticRenderFns } from "./ModalFidelizacao.vue?vue&type=template&id=783d919f&scoped=true"
import script from "./ModalFidelizacao.vue?vue&type=script&lang=ts"
export * from "./ModalFidelizacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalFidelizacao.vue?vue&type=style&index=0&id=783d919f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d919f",
  null
  
)

export default component.exports